import React from 'react'
import { useTranslation } from 'next-i18next'
import { CustomTitle } from 'src/components'
import { UsersAdmin } from 'src/core/models'

const UserAdminTypeColumn: React.FC<{ user: UsersAdmin }> = ({ user }) => {
  const { t } = useTranslation()

  const typeLabel = {
    individual: t('Validate.Individual'),
    business: t('Validate.Business')
  }[user.user_type]

  return <CustomTitle label={typeLabel} type={null} />
}

export default UserAdminTypeColumn
